/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Seo_KeywordsInputs */

const cs_form_seo_keywords = /** @type {(inputs: Form_Seo_KeywordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SEO klíčová slova`)
};

const en_form_seo_keywords = /** @type {(inputs: Form_Seo_KeywordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SEO keywords`)
};

/**
* | output |
* | --- |
* | "SEO keywords" |
*
* @param {Form_Seo_KeywordsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_seo_keywords = /** @type {((inputs?: Form_Seo_KeywordsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Seo_KeywordsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_seo_keywords(inputs)
	return cs_form_seo_keywords(inputs)
});